import { MouseEvent, useContext } from 'react'
import { UserContext } from 'context/userContext'
import { LogoutButton, MenuButton, FakeMenuButton } from './style'

interface IMenuButtonProps {
  icon: any
  children?: string
  onClick?: (_e: MouseEvent<HTMLElement>) => void
  name: string
  active?: boolean
  extended: boolean
  to?: string
  logoutButton?: boolean
  disabled?: boolean
  renderBorder?: boolean
}

export default function MenuComponent({
  icon,
  children,
  extended,
  active,
  to,
  logoutButton,
  disabled,
  ...rest
}: IMenuButtonProps) {
  const { setExtended } = useContext(UserContext)
  return logoutButton ? (
    <LogoutButton extended={extended} active={active} {...rest} to={to || ''}>
      <span>{children}</span>
      <img src={icon} alt="menuIcon" />
    </LogoutButton>
  ) : !disabled ? (
    <MenuButton
      onClick={() => setExtended(false)}
      extended={extended}
      active={!disabled && active}
      {...rest}
      to={to || ''}
    >
      <img src={icon} alt="menuIcon" />
      <span>{children}</span>
    </MenuButton>
  ) : (
    <FakeMenuButton extended={extended} {...rest}>
      <img src={icon} alt="menuIcon" />
      <span>{children}</span>
    </FakeMenuButton>
  )
}
